export enum FioCallOutcome {
    Success = 0,
    HttpError = 1,
    ParseError = 2,
    NetworkError = 3,
}

export interface MatchedInvoiceDto {
    invoiceId: string
    invoiceNumber: number
    paidAt: string
    amount: number
    clientName: string
    eventName: string
    issuerName: string
}

export interface TokenCheckResultDto {
    issuerName: string
    safeTokenId: string
    outcome: FioCallOutcome
    matchedCount: number
    fromDate: string
    httpStatusCode: number | null
    errorMessage: string | null
}

export interface ForcePaymentCheckResultDto {
    alreadyRunning: boolean
    tokenResults: TokenCheckResultDto[]
    matchedInvoices: MatchedInvoiceDto[]
}
